import React from 'react';
import { 
    Home, Receipt, Building, Key, 
    Calculator, PiggyBank, Hammer, 
    Construction, Scale, Gavel, 
    Banknote, Landmark, FileText,
    Users, Briefcase, HardHat,
    Building2, HomeIcon, Bank,
    FileWarning, 
    FileClock,
    FileCheck, 
    HandCoins,
    ScrollText,
    Shield,
    BadgeAlert,
    BadgeDollarSign,
    Siren,
    HelpCircle,
    FileSignature,
    ShieldAlert,
    UserCog,
    ClipboardSignature,
    ClipboardCheck,
    Stamp,
    Award,
    UserX,
    Coins,
    AlertTriangle,
    Stethoscope,        // תאונות רפואיות
    Ambulance,          // תאונות דרכים
    ClipboardList,
    ShieldCheck,        // ביטוח
    School,            // תאונות תלמידים
    Wheelchair,
    Heart,
    Car,               // רכב
    PersonStanding,
    GraduationCap,     // תלמידים
    TrafficCone,
    Factory,       // מבנה תעשייה
    Warehouse,     // מחסן/מבנה מסחרי
    Store,         // חנות
  
    Hotel          // מלון
  } from 'lucide-react';
  import { IoBusinessSharp } from "react-icons/io5";
import {  X } from 'lucide-react';
const icons = [

{ component: Heart, name: 'Heart', label: 'פגיעה' },
{ component: Stethoscope, name: 'Stethoscope', label: 'טיפול רפואי' },
{ component: PersonStanding, name: 'PersonStanding', label: 'אדם עומד'},
{ component: TrafficCone, name: 'TrafficCone', label: 'קונוס' },
{ component: Building2, name: 'Building2', label: 'מבנה ציבורי' },
{ component: BadgeAlert, name: 'BadgeAlert', label: 'תאונה' },
{ component: HardHat, name: 'HardHat', label: 'בטיחות בעבודה' },
{ component: FileWarning, name: 'FileWarning', label: 'תביעה' },
{ component: ClipboardList, name: 'ClipboardList', label: 'דוח תאונה' },
    { component: Home, name: 'Home', label: 'בית' },
    { component: Receipt, name: 'Receipt', label: 'חוזה' },
    { component: Building, name: 'Building', label: 'בניין' },
    { component: Landmark, name: 'LandmarkCourt', label: 'בית משפט' }, // שינוי השם
{ component: Key, name: 'Key', label: 'מפתח' },
{ component: Calculator, name: 'Calculator', label: 'מחשבון' },
{ component: PiggyBank, name: 'PiggyBank', label: 'קופת חיסכון' },
{ component: Hammer, name: 'Hammer', label: 'פטיש' },
{ component: Construction, name: 'Construction', label: 'בנייה' },
{ component: Scale, name: 'Scale', label: 'מאזניים' },
{ component: Gavel, name: 'Gavel', label: 'פטיש שופט' },
{ component: Banknote, name: 'Banknote', label: 'שטר כסף' },
{ component: Landmark, name: 'Landmark', label: 'בנק' },
{ component: FileText, name: 'FileText', label: 'מסמך' },
{ component: Users, name: 'Users', label: 'אנשים' },
{ component: Ambulance, name: 'Ambulance', label: 'תאונות דרכים' },
{ component: ShieldCheck, name: 'ShieldCheck', label: 'ביטוח' },
{ component: School, name: 'School', label: 'תאונות תלמידים' },
{ component: Car, name: 'Car', label: 'רכב' },
{ component: GraduationCap, name: 'GraduationCap', label: 'תלמידים' },
{ component: Stethoscope, name: 'Stethoscope', label: 'תאונות רפואיות' },
 { component: Factory, name: 'Factory', label: 'מבנה תעשייה' },
 { component: Warehouse, name: 'Warehouse', label: 'מבנה מסחרי' },
 { component: Store, name: 'Store', label: 'חנות' },
 { component: Hotel, name: 'Hotel', label: 'מלון' },
    { component: Key, name: 'Key', label: 'מפתח' },
    { component: Calculator, name: 'Calculator', label: 'מחשבון' },
    { component: PiggyBank, name: 'PiggyBank', label: 'קופת חיסכון' },
    { component: Hammer, name: 'Hammer', label: 'פטיש' },
    { component: Construction, name: 'Construction', label: 'בנייה' },
    { component: Scale, name: 'Scale', label: 'מאזניים' },
    { component: Gavel, name: 'Gavel', label: 'פטיש שופט' },
    { component: Banknote, name: 'Banknote', label: 'שטר כסף' },
    { component: Landmark, name: 'Landmark', label: 'בנק' },
    { component: FileText, name: 'FileText', label: 'מסמך' },
    { component: Users, name: 'Users', label: 'אנשים' },
    { component: Briefcase, name: 'Briefcase', label: 'תיק' },
    { component: HardHat, name: 'HardHat', label: 'קסדה' },
    { component: Building2, name: 'Building2', label: 'מגדל' },
    { component: HomeIcon, name: 'HomeIcon', label: 'דירה' },
    { component: FileWarning, name: 'FileWarning', label: 'תיק חדלות פירעון' },
    { component: HandCoins, name: 'HandCoins', label: 'תשלומים' },
    { component: BadgeDollarSign, name: 'BadgeDollarSign', label: 'חובות' },
    { component: ScrollText, name: 'ScrollText', label: 'צווים' },
    { component: Stamp, name: 'Stamp', label: 'אישור רשמי' },
    { component: UserX, name: 'UserX', label: 'חייב' },
    { component: Coins, name: 'Coins', label: 'כספים' },
    { component: FileCheck, name: 'FileCheck', label: 'אישור הסדר' },
    { component: FileSignature, name: 'FileSignature', label: 'הסדר חוב' },
    { component: UserCog, name: 'UserCog', label: 'ניהול תיק' },
    { component: ClipboardCheck, name: 'ClipboardCheck', label: 'אישור' },
    { component: AlertTriangle, name: 'AlertTriangle', label: 'התראה' },
    { component: ShieldAlert, name: 'ShieldAlert', label: 'תביעת נזיקין' },
    { component: FileClock, name: 'FileClock', label: 'התיישנות' },
    { component: Shield, name: 'Shield', label: 'הגנה משפטית' },
    { component: HelpCircle, name: 'HelpCircle', label: 'ייעוץ משפטי' },
    { component: ClipboardSignature, name: 'ClipboardSignature', label: 'תצהיר' },
    { component: Award, name: 'Award', label: 'פיצויים' }
  ];

const IconSelector = ({ selectedIcon, onSelect, onClose }) => {
    return (
      <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center p-2 sm:p-4">
        <div className="bg-white rounded-xl shadow-xl w-full max-w-[95vw] sm:max-w-4xl max-h-[90vh] overflow-hidden">
          {/* Header */}
          <div className="sticky top-0 bg-white p-3 sm:p-4 border-b flex justify-between items-center">
            <h3 className="text-base sm:text-lg font-semibold">בחר אייקון</h3>
            <button 
              onClick={onClose}
              className="p-2 hover:bg-gray-100 rounded-full text-gray-500 hover:text-gray-700"
              aria-label="סגור"
            > 
              <X className="w-5 h-5" />
            </button>
          </div>
          
          {/* Icons Grid */}
          <div className="p-3 sm:p-6 overflow-y-auto max-h-[calc(90vh-80px)]">
            <div className="grid grid-cols-3 sm:grid-cols-4 md:grid-cols-6 gap-2 sm:gap-4">
              {icons.map((icon) => {
                const IconComponent = icon.component;
                return (
                  <button
                    key={icon.name}
                    onClick={() => {
                      onSelect(icon.name);
                      onClose();
                    }}
                    className={`p-2 sm:p-4 rounded-lg flex flex-col items-center gap-1 sm:gap-2 hover:bg-gray-50 transition-colors
                      ${selectedIcon === icon.name ? 'ring-2 ring-blue-500 bg-blue-50' : 'border'}
                    `}
                  >
                    <IconComponent className="w-6 h-6 sm:w-8 sm:h-8 text-gray-700" />
                    <span className="text-xs sm:text-sm text-gray-600 text-center line-clamp-1">{icon.label}</span>
                  </button>
                )
              })}
            </div>
          </div>
        </div>
      </div>
    );
  };

export { icons, IconSelector };